export const ORDER_TYPES = {
  BULK_ENROLLMENT: 'Enrollment Code',
  ENTITLEMENT: 'Course Entitlement',
  SEAT: 'Seat',
};

export const CERTIFICATE_TYPES = {
  VERIFIED: 'verified',
  CREDIT: 'credit',
};
